import { useMemo } from 'react';
import { useGeoLocation } from './useGeoLocation';
import restrictions from '../restrictions';
export const useLinks = (links) => {
    const geo = useGeoLocation();
    const allLinks = useMemo(() => {
        // dont show restricted items if no geo (dont show restricted just in case)
        if (!geo)
            return links.filter(l => !l.restricted);
        // filter out replacement items
        const replacements = links
            .filter(l => l.restricted)
            .reduce((p, c) => {
            if (!c.restricted)
                return p;
            return Object.assign(Object.assign({}, p), { [c.restricted.replace]: restrictions[c.restricted.map] });
        }, {});
        return links.reduce((p, c) => {
            var _a, _b, _c;
            // remove restricted items
            if (c.restricted && ((_a = restrictions[c.restricted.map]) === null || _a === void 0 ? void 0 : _a.includes(geo))) {
                return p;
            }
            // replace items if unrestrected
            if (((_b = Object.keys(replacements)) === null || _b === void 0 ? void 0 : _b.includes(c.key)) &&
                !((_c = replacements[c.key]) === null || _c === void 0 ? void 0 : _c.includes(geo))) {
                return p;
            }
            // no filtering required
            return [...p, c];
        }, []);
    }, [geo, links]);
    return allLinks;
};
//# sourceMappingURL=useLinks.js.map